import { render, staticRenderFns } from "./tiger.vue?vue&type=template&id=d59b46bc&scoped=true&"
import script from "./tiger.vue?vue&type=script&lang=js&"
export * from "./tiger.vue?vue&type=script&lang=js&"
import style0 from "./tiger.vue?vue&type=style&index=0&id=d59b46bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59b46bc",
  null
  
)

export default component.exports